__turbopack_context__.v({
  "alertInlineContainer": "PlanSummary-module__VteVNW__alertInlineContainer",
  "container": "PlanSummary-module__VteVNW__container",
  "disclaimerContainer": "PlanSummary-module__VteVNW__disclaimerContainer",
});
